export class ServicioGasto {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    // public readonly CategoriaGastoId: number,
    // public readonly CategoriaGastoNombre: string | null,
    public readonly ServicioGrupoId: number | null,
    public readonly ServicioGrupoNombre: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchServicioGastoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    // public readonly CategoriaGastoId: number | null,
    public readonly ServicioGrupoId: number | null,
    public readonly TipoGastoComunidadId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveServicioGastoDto {
  constructor(
    public Nombre: string | null,
    public Codigo: string | null,
    // public CategoriaGastoId: number,
    public ServicioGrupoId: number | null,
    public Activo: boolean
  ) {}
}

export class SearchServicioGastoResponse {
  constructor(
    public readonly count: number,
    public readonly result: ServicioGasto[]
  ) {}
}
